// 🔧 image_generator.js
// ✅ Purpose: Generates image metadata for LGV Seed Engine entries
// ✅ Features:
// - Provides a single place for entry image assignment logic
// - Starts with safe placeholder image metadata
// - Future-ready for stock demo photos, uploaded demo assets, and AI-generated images
// - Keeps image concerns separate from entry generation
// - Fully block-commented for clarity and future devs

import { getDemoEntryImageAsset } from "../../utils/demo_entry_assets";

export const generateImagesForEntry = ({
  entry,
  industryKey = "car_show",
} = {}) => {
  const imageUrl = getDemoEntryImageAsset(industryKey);

  return {
    thumbnail: imageUrl,

    gallery: [imageUrl],

    placeholder: false,

    source: "bundled_demo_asset",

    industryKey,

    altText:
      entry?.title
        ? `${entry.title} demo entry image`
        : "Seeded demo entry image",
  };
};
